// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"rss"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4 4C12.8366 4 20 11.1634 20 20M4 11C8.97056 11 13 15.0294 13 20M5 20C4.44772 20 4 19.5523 4 19C4 18.4477 4.44772 18 5 18C5.55228 18 6 18.4477 6 19C6 19.5523 5.55228 20 5 20Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const RssIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'rss',
    ref,
    icon: element,
  },
));

RssIcon.displayName = 'RssIcon';

export default RssIcon;
